/* @jsxImportSource @emotion/react */
import React from 'react'

import { ArrowRightIcon } from '@slite/icons'

import { fontSize } from './constants'

const TAG_SEPARATOR = '·'

const logoCss = {
  maxHeight: 24,
  maxWidth: 140,
  objectFit: 'contain',
  objectPosition: 'left center',
} as const

const descriptionCss = {
  fontSize: fontSize.small,
  lineHeight: 1.5,
  '& p + p': { marginTop: 8 },
  '& a': { color: 'inherit', textDecoration: 'underline' },
} as const

// The icon set has no diagonal arrow.
const northEastArrowCss = { transform: 'rotate(-45deg)' } as const

/** For ArticleLayout's `sidebarHeader`. The website link only shows beside the logo. */
export function ArticleCompanySummary(props: {
  logoUrl?: string
  logoAlt?: string
  websiteUrl?: string
  websiteLabel: string
  description?: React.ReactNode
  tags?: string[]
}) {
  const tags = props.tags ?? []

  return (
    <div className="flexbox flexbox-column flexbox-gap-12">
      {props.logoUrl && (
        <div className="flexbox flexbox-align-center flexbox-gap-12 margin-bottom-8">
          <img
            src={props.logoUrl}
            alt={props.logoAlt ?? ''}
            className="block"
            css={logoCss}
          />
          {props.websiteUrl && (
            <a
              href={props.websiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="margin-left-auto flexbox-inline padding-4 shade-20 shade-05-on-hover"
              aria-label={props.websiteLabel}
              title={props.websiteLabel}
            >
              <ArrowRightIcon
                size={16}
                aria-hidden="true"
                css={northEastArrowCss}
              />
            </a>
          )}
        </div>
      )}

      {props.description && (
        <div className="shade-10" css={descriptionCss}>
          {props.description}
        </div>
      )}

      {tags.length > 0 && (
        <div
          className="shade-05 font-weight-semibold padding-top-8"
          css={{ fontSize: fontSize.small }}
        >
          {tags.map((tag, index) => (
            <React.Fragment key={tag}>
              {index > 0 && (
                <span className="padding-horizontal-8" aria-hidden="true">
                  {TAG_SEPARATOR}
                </span>
              )}
              {tag}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  )
}
